import React, { useState } from 'react';
import { TextField } from '@material-ui/core';

interface Props {
    value: string | undefined,
    type: string,
    placeholder: string,
    hasKarteNo?: boolean,
    onChange: (newValue: any) => void,
}

export default ((props) => {
    const val = props.value !== undefined ? props.value : '';
    const [errorMessage, setErrorMessage] = useState<string>();

    const handleChange = (value: string) => {
        if (props.placeholder === 'remarks') {
            if (props.hasKarteNo) {
                if (!value.match(/^[ァ-ンヴーｧ-ﾝﾞﾟ\-0-9a-zA-Z]*$/) || value.length > 10) {
                    setErrorMessage('(カタカナ英数字、10文字以内)');
                } else {
                    setErrorMessage('');
                }
            } else {
                if (!value.match(/^[ァ-ンヴーｧ-ﾝﾞﾟ\-0-9a-zA-Z]*$/) || value.length > 20) {
                    setErrorMessage('(カタカナ英数字、20文字以内)');
                } else {
                    setErrorMessage('');
                }
            }
        }

        if (props.value !== value) {
            props.onChange(value);
        }
    };

    return (
        <TextField
            required
            type={props.type}
            placeholder={props.placeholder}
            size="small"
            value={val}
            error={errorMessage ? true : false}
            helperText={errorMessage}
            onChange={(event) => handleChange(event.target.value as string)}
        />

    );
}) as React.FC<Props>;
